export default __webpack_public_path__ + "static/media/Bruno Tavares.d988bf20.png";